import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f81cec8a")

_pushScopeId("data-v-f81cec8a")
const _hoisted_1 = { class: "text-14 pt-f5 leading-5 text-gray-600 cursor-pointer normal-case" }
const _hoisted_2 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_c_form_error_icon = _resolveComponent("c-form-error-icon")

  return (_openBlock(), _createBlock("div", {
    class: "c-form-input min-w-3 flex flex-col mt-f5",
    title: _ctx.error ? _ctx.useGlobalTranslations(`errors.${_ctx.error}`) : ''
  }, [
    _createVNode("label", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createBlock("span", _hoisted_2, "*"))
        : _createCommentVNode("", true),
      _createVNode(_component_c_form_error_icon, { error: _ctx.error }, null, 8, ["error"]),
      _createVNode("input", _mergeProps({
        ref: "input",
        autocomplete: "off",
        class: ["c-form-input__input bg-gray-200 p-f13 h-14 rounded-3xl md:h-14 min-w-full text-black text-12 md:rounded-full placeholder-gray-600 focus:outline-none mt-f8", [
          _ctx.inputTypeNumber,
          _ctx.error ? 'border border-red-500 placeholder-red-800' : '',
        ]],
        disabled: _ctx.disabled,
        placeholder: _ctx.placeholder
      }, _ctx.$attrs, {
        tabindex: "1",
        type: _ctx.type,
        value: _ctx.modelValue,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
      }), null, 16, ["disabled", "placeholder", "type", "value"])
    ])
  ], 8, ["title"]))
})